import Create from "./Create";
import List from "./List";
import Show from "./Show";

export const NotificationCreate = Create;
export const NotificationList = List;
export const NotificationShow = Show;
